import { createRouter, createWebHistory } from 'vue-router';

// Page List

import escoLogin from '../views/esco-login.vue';
import escoTelaPrincipal from '../views/esco-tela-principal.vue';
import escoConversaEmAndamento from '../views/esco-conversa-em-andamento.vue';
import escoChatDeQuestoes from '../views/esco-chat-de-questoes.vue';
// import escoConversaDefault from '../views/esco-conversa-default.vue';
import escoConversaEmAndamentoOrder from '../views/esco-conversa-em-andamento-order.vue';
import escoAtivarConta from '../views/esco-ativar-conta.vue';
import escoEsqueciSenha from '../views/esco-esqueci-senha.vue';


const routes = [

    // Page - Login

    {
        path: '/',
        name: 'Login',
        component: escoLogin
    },

    // Page - Conversa Default

    // {
    //     path: '/conversa-default',
    //     name: 'Conversa Default',
    //     component: escoConversaDefault
    // },

    // Page - Conversa Em Andamento

    {
        path: '/conversa-em-andamento/:slug',
        name: 'Conversa Em Andamento',
        component: escoConversaEmAndamentoOrder
    },
    // Page - Tela Principal

    {
        path: '/tela-principal',
        name: 'Tela Principal',
        component: escoTelaPrincipal
    },

    // Page - Conversa Em Andamento

    {
        path: '/chat',
        name: 'Chat',
        component: escoConversaEmAndamento
    },

    // Page - Chat De Questoes

    {
        path: '/chat-de-questoes',
        name: 'Chat De Questoes',
        component: escoChatDeQuestoes
    },
    {
        path: '/ativar-conta/:slug',
        name: 'Ativar Conta',
        component: escoAtivarConta
    },
    {
        path: '/esqueci-senha',
        name: 'Esqueci Senha',
        component: escoEsqueciSenha
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

export default router;
